import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

/**
 * @typedef {object} LinkButtonOwnProps
 * @property {string|number} [to]
 * @property {boolean} [disabled]
 */

/**
 * @typedef {LinkButtonOwnProps & Partial<React.ComponentPropsWithoutRef<typeof Link>>} LinkButtonProps
 */

/**
 * @type {React.ForwardRefExoticComponent<LinkButtonProps & React.RefAttributes<*>>}
 * @param {LinkButtonProps} props
 */
const LinkButton = forwardRef((props, ref) => {
  const { className, disabled = false, children, to = '' } = props;

  return (
    <Link
      {...props}
      to={to}
      ref={ref}
      className={cx('link-button', className, { disabled: disabled })}>
      <span>{children}</span>
    </Link>
  );
});

LinkButton.displayName = 'LinkButton';

export default LinkButton;
